import React, { useEffect, useState } from 'react';
import UIStore from '@/stores/UIStore';
import { LeftOutlined, PlusOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Card, Divider, message, notification, Tag, Tooltip, Typography } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { QuoteRevisions } from 'components/Quotes';
import api from 'utils/api';
import FourOhFour from 'pages/404';
import { ErrorRender } from '@partsbadger/library';

import { AdditionalRequirementsProps, QuoteLineItemProps, QuoteProps } from '../../../types/types';
import { PageHeader } from 'components/PageHeader';

import dayjs from 'dayjs';
import PortalLoading from 'components/PortalLoading';

const { Title, Text } = Typography;

interface IProps {
    match: {
        params: {
            id: number;
        };
    };
}

export const QuoteModificationsList: React.FC<IProps> = props => {
    const history = useHistory<any>();
    const { id } = props.match.params;

    const [quote, setQuote] = useState<QuoteProps>();
    const [lineItems, setLineItems] = useState<QuoteLineItemProps[]>([]);
    const [notFound, setNotFound] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const record = history.location.state?.record;

    const loadQuote = async () => {
        await api.Quotes.getQuote(id)
            .then(data => {
                setQuote(data);
                setLoading(false);
            })
            .catch(error => {
                notification.error({
                    duration: 10,
                    message: 'Error',
                    description: <ErrorRender error={error} />,
                    placement: 'bottomRight',
                });
                setNotFound(true);
            });
    };

    const getLineItems = async () => {
        await api.Quotes.lineItems(id)
            .then(response => {
                setLineItems(response.results);
            })
            .catch(error => {
                notification.error({
                    duration: 10,
                    message: 'Error',
                    description: <ErrorRender error={error} />,
                    placement: 'bottomRight',
                });
            });
    };

    useEffect(() => {
        UIStore.setSelectedKey(['quotes']);
        UIStore.setDocumentTitle('Quote Revisions');
        setLoading(true);
        setNotFound(false);
        if (id) {
            if (record?.quote) {
                setQuote(record?.quote);
                setLoading(false);
            } else {
                // not passed as prop
                loadQuote();
            }

            if (record?.line_items) {
                setLineItems(record?.line_items);
            } else {
                // not passed as prop
                getLineItems();
            }
        }
    }, [id]);

    if (notFound) {
        return <FourOhFour />;
    }

    const newRevision = async () => {
        if (quote) {
            return await api.Quotes.newRevision(quote.id)
                .then(data => {
                    message.success(`Revision ${data.name} created`);
                    history.push(`/my-account/quotes/${data.id}/order/`);
                })
                .catch((err: any) => {
                    notification.error({
                        duration: 10,
                        message: 'Error',
                        description: <ErrorRender error={err} />,
                        placement: 'bottomRight',
                    });
                });
        }

        notification.error({
            duration: 10,
            message: 'Error',
            description: 'The quote does not exist',
            placement: 'bottomRight',
        });
    };

    return (
        <>
            <div className="bg-white border-bottom mb-3 pt-3 pb-3" style={{ paddingBottom: '2rem' }}>
                <div className="container">
                    {/* <Button
                        type="link"
                        icon={<ArrowLeftOutlined />}
                        onClick={() => {
                            history.goBack();
                        }}
                        className="text-primary m-0 p-0"
                    >
                        Back to Original Quote
                    </Button> */}
                    <div className="flex flex-col md:flex-row justify-between mb-2">
                        <div className="flex flex-col md:flex-row align-center">
                            <Title level={1} className="mb-3 mr-2">
                                Quote Modifications
                            </Title>

                            <div>
                                {quote?.has_dynamic_quantities ? (
                                    <Tag color="green" style={{ fontSize: 11, margin: 0, lineHeight: 2 }}>
                                        Dynamic Quote
                                    </Tag>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <Link to={`/quote/`} className="font-size-md">
                        {quote?.name}
                    </Link>
                </div>
            </div>

            {loading || !quote ? (
                <PortalLoading />
            ) : (
                <>
                    <div className="container">
                        <div className={'purchase-order'}>
                            {quote && (
                                <Card>
                                    <QuoteRevisions parent_quote={quote.id} />
                                </Card>
                            )}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
